import api from '../../../services/api';

const API_URL = '/api/v1/admin/awardingRuleSet';
/**
 * @returns {Promise<ApiAdmin.GetAllAwardingRules>}
 */
// eslint-disable-next-line import/prefer-default-export
export const getAllAwardingRules = () => api.get(API_URL);

/**
 * @param {number} awardingRuleId
 * @returns {Promise<ApiAdmin.SaveAwardingRuleResponse>}
 */
export const getAwardingRule = (awardingRuleId) => api.get(`${API_URL}/${awardingRuleId}`);

/**
  * @param {AwardingRule.IAwardingRuleBrief} awardingRuleInformation
  * @returns {Promise<ApiAdmin.SaveAwardingRuleResponse>}
  */
export const createAwardingRule = (awardingRuleInformation) => api.post(`${API_URL}/`, awardingRuleInformation);

/**
  * @param {number} awardingRuleId
  * @param {AwardingRule.IAwardingRuleBrief} awardingRuleInformation
  * @returns {Promise<ApiAdmin.SaveAwardingRuleResponse>}
  */
// eslint-disable-next-line max-len
export const updateAwardingRule = (awardingRuleId, awardingRuleInformation) => api.put(`${API_URL}/${awardingRuleId}`, awardingRuleInformation);

/**
  * @param {number} awardingRuleId
  * @returns {Promise<import('axios').AxiosResponse<any>>}
  */
export const deleteAwardingRule = (awardingRuleId) => api.delete(`${API_URL}/${awardingRuleId}`);

/**
  * @returns {Promise<ApiAdmin.GetAllCustomDateFormatResponse>}
  */
export const getAllCustomDateFormat = () => api.get(`${API_URL}/CustomDateFormat`);
